import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  nextButtonPlaceholder: {
    width: theme.spacing(8.75),
    height: theme.spacing(4),
  },
  nextButton: {
    width: theme.spacing(8.75),
    height: theme.spacing(4),
  },
}));

export default useStyles;
